import { defineComponent as _defineComponent } from 'vue'
import { useField } from "vee-validate";
import BaseInput from "./_base.vue";
import Multiselect from "@vueform/multiselect";

interface Props {
    name: string;
    label?: string;
    placeholder: string;
    options: Array<{ value: string; label: string }>;
    inputClass?: string;
    mode: "single" | "tags";
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: { type: String, required: true, default: undefined },
    label: { type: String, required: false, default: undefined },
    placeholder: { type: String, required: true, default: undefined },
    options: { type: Array, required: true },
    inputClass: { type: String, required: false, default: "md" },
    mode: { type: String, required: true, default: "tags" }
  },
  setup(__props: any, { expose }) {

const props = __props as { name: string, label: string, placeholder: string, options: Array<{ value: string; label: string }>, inputClass: string, mode: "single" | "tags" }



const { value, handleChange, handleBlur, errorMessage, meta } = useField(props.name);
const mode = typeof value.value === "string" ? "single" : props.mode;
const delayedBlur = () => setTimeout(handleBlur, 500);

expose({ value });

const __returned__ = { props, value, handleChange, handleBlur, errorMessage, meta, mode, delayedBlur, BaseInput, Multiselect }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})